import { Directive, forwardRef } from '@angular/core';
import { NG_VALIDATORS, FormControl } from '@angular/forms';

function NoWhitespaceValidatorFactory() {
    return (c: FormControl) => {
        let isWhitespace = (c.value || '').trim().length === 0;
        let isValid = !isWhitespace;
        return isValid ? null : {
            noWhitespace: {
              valid: false
            }
        }
    }
}


@Directive({
  selector: '[noWhitespace][ngModel],[noWhitespace][formControl]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => NoWhitespaceValidatorDirective), multi: true }
  ]
})

export class NoWhitespaceValidatorDirective {

    validator: Function;

  constructor() {
    this.validator = NoWhitespaceValidatorFactory();
  }

  validate(c: FormControl) {
    return this.validator(c);
  }


}
